<i18n>
{
    "en": {
        "It has been started {time} ago and is currently at {percentage}%.": "It has been started {time} ago and is currently at {percentage}%.",
        "File: {file}": "File: {file}",
        "Error: {error}": "Error: {error}",
        "Started: {time}": "Started: {time}",
        "The Last import has been finished successfully {time} ago.": "The Last import has been finished successfully {time} ago.",
        "Missing identifier. There must be either an \"ID\" or an \"NR\" column.": "Missing identifier. There must be either an \"ID\", \"EMAIL\" or an \"NR\" column.",
        "The last import could not be completed successfull. It failed {time} ago.": "The last import could not be completed successfull. It failed {time} ago.",
        "Estimated completion: {time}.": "Estimated completion: {time}.",
        "Import {number} people": "Import {number} people"
    },
    "de": {
        "Something went wrong!": "Etwas ist schiefgelaufen!",
        "The uploaded CSV ist invalid.": "Die hochgeladene CSV ist ungültig.",
        "The columns of the uploaded import file could be fully recognized.": "Die Spalten der hochgeladenen Importdatei konnten vollständig erkannt/zugeordnet werden.",
        "The columns of the uploaded import file could not be fully recognized.": "Die Spalten der hochgeladenen Importdatei konnten nicht vollständig erkannt/zugeordnet werden.",
        "You can now start the import.": "Der Import kann jetzt gestartet werden",
        "Start import": "Import starten",
        "Cancel": "Abbrechen",
        "Missing identifier. There must be either an \"ID\" or an \"NR\" column.": "Es fehlt die Spalte zur Kennung des Kunden. Es muss entweder die Spalte \"ID\", \"EMAIL\" oder \"NR\" vorhanden sein",
        "Missing SKU. There must be either an \"SKU\" or an \"EAN\" column.": "Es fehlt die Spalte zur Kennung des Artikels. Es muss entweder die Spalte \"SKU\" oder \"EAN\" vorhanden sein",
        "Check your import file and try again after said issues has been fixed.": "Überprüfen Sie Ihre Importdatei und versuchen Sie es erneut, nachdem die genannten Probleme behoben wurden.",
        "The following fields are not supported.": "Die folgenden Felder werden nicht unterstützt.",
        "The following lines are invalid. They have an unexpected number of columns.": "Die folgenden Zeilen haben eine unerwartete Anzahl an Spalten.",
        "Error: {error}": "Fehler: {error}",
        "The most recent import failed": "Der zuletzt ausgeführte Import ist fehlgeschlagen",
        "Technical issue! Wish List import could not be initialized.": "Technisches Problem! Wunschlisten-Import konnte nicht initialisiert werden.",
        "Wish List import could not be refreshed.": "Wunschlisten-Import konnte nicht aktualisiert werden.",
        "Wish List import could not be started.": "Wunschlisten-Import konnte nicht gestartet werden.",
        "An import is in the queue and will start as soon as possible.": "Aktuell befindet sich bereits ein Import in der Warteschlange und wird so schnell wie möglich gestartet.",
        "An import is currently running.": "Aktuell befindet sich bereits ein Import in der Verarbeitung.",
        "Import {number} people": "Importiere {number} Personen",
        "It has been started {time} ago and is currently at {percentage}%.": "Der Import wurde vor {time} gestartet und ist aktuell bei {percentage}%.",
        "File: {file}": "Datei: {file}",
        "Started: {time}": "Gestartet vor: {time}",
        "The Last import has been finished successfully {time} ago.": "Der letzte import wurde erfolgreich abgeschlossen vor {time}.",
        "The last import could not be completed successfull. It failed {time} ago.": "Der letzte Import konnte nicht erfolgreich abgeschlossen werden. Fehlgeschlagen vor {time}.",
        "Estimated completion: {time}.": "Voraussichtliche Dauer bis zur Fertigstellung: {time}",
        "Your import has been queued and will start as soon as possible.": "Dein Import wurde erfolgreich erfasst und wird so schnell wie möglich gestartet.",
        "Please check later": "Schau doch später nochmal vorbei",
        "The import has been completed.": "Der Import wurde erfolgreich abgeschlossen.",
        "or refresh now": "oder aktualisiere jetzt",
        "Import": "Importieren",
        "Try again": "Erneut versuchen"
    }
}
</i18n>

<script>
import _ from 'lodash'
import { formatDistanceToNow, fromUnixTime, getUnixTime } from 'date-fns';

import { adminClient as apolloClient } from '@/store/apollo';

import { isTokenValidOrUndefined, fetchAccessToken } from '@/helpers'

import AuthApi from '@/store/api/system/auth';
import ProductCsvImport from '@/extensions/shop/components/Products/ProductCsvImport';
import { useShopWishListStore } from '@/stores';
import pinia from '@/pinia';

export default {
    name: 'WishListCsvImport',
    extends: ProductCsvImport,
    computed: {
        shopWishListStore() {
            return useShopWishListStore(pinia);
        }
    },
    methods: {
        validateCsv() {
            if (this.file) {
                this.validating = true;
                const payload = {
                    shopID: _.get(this.activeCms, 'shop.id'),
                    file: this.file,
                }
                this.shopWishListStore.validateWishListImportCsv(payload)
                    .then(data => {
                        this.validationResult = data;
                        this.file = data.file;
                    })
                    .catch(error => {
                        let message
                        const { graphQLErrors } = error
                        if (graphQLErrors && graphQLErrors.length > 0) {
                            message = graphQLErrors[0].details
                        }

                        // eslint-disable-next-line
                        console.error(error);
                        this.error = this.$t('Wish List import could not be refreshed.')
                        this.$notify.error({
                            title: this.$t('Something went wrong!'),
                            message,
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000,
                        })
                    })
                    .finally(() => {
                        this.validating = false
                    })
            }
        },
        start() {
            if (this.file) {
                this.initializing = true;
                this.shopWishListStore.initializeWishListImport({
                    shopID: _.get(this.activeCms, 'shop.id'),
                    file: this.file,
                })
                    .then(data => {
                        this.error = false;
                        this.overview = data;
                        this.file = undefined;
                        this.validationResult = undefined;
                    })
                    .catch(error => {
                        // eslint-disable-next-line
                        console.error(error);
                        this.error = this.$t('Technical issue! Wish List import could not be initialized.')
                        this.$notify.error({
                            title: this.$t('Something went wrong!'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000,
                        })
                    })
                    .finally(() => {
                        this.initializing = false
                    });
            } else {
                this.$notify.error({
                    title: this.$t('Something went wrong!'),
                    iconClass: 'fas el-icon-fa-times',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000,
                })
            }
        },
        refresh() {
            apolloClient.clearStore().then(() => {
                this.$emit('refresh')
                this.shopWishListStore.initializeWishListImport({ shopID: _.get(this.activeCms, 'shop.id') })
                    .then(data => {
                        this.error = false;
                        this.overview = data;
                        this.file = undefined;
                    })
                    .catch(error => {
                        // eslint-disable-next-line
                        console.error(error);
                        this.error = this.$t('Wish List import could not be refreshed.')
                        this.$notify.error({
                            title: this.$t('Something went wrong!'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000,
                        })
                    })
                    .finally(() => {
                        this.initializing = false
                    });
            });
        },
    },
    mounted() {
        this.initializing = true;
        this.shopWishListStore.initializeWishListImport({ shopID: _.get(this.activeCms, 'shop.id') })
            .then(data => {
                this.overview = data
            })
            .finally(() => {
                this.initializing = false
            })
    }
}
</script>
